var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#616160;display:inline !important;}\r\n\t.st1{display:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.2,8.8l-0.4-0.4c-0.1-0.1-0.3-0.1-0.4,0l-2,2V1.2C8.5,1.1,8.4,1,8.3,1H7.8C7.6,1,7.5,1.1,7.5,1.2v9.2l-2-2 c-0.1-0.1-0.3-0.1-0.4,0L4.8,8.8C4.7,8.9,4.7,9,4.8,9.1l3.1,3.1c0.1,0.1,0.3,0.1,0.4,0l3.1-3.1C11.3,9,11.3,8.9,11.2,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,10v4.3H2V10c0-0.1-0.1-0.2-0.2-0.2H1.2C1.1,9.7,1,9.9,1,10v4.8c0,0.3,0.2,0.5,0.5,0.5h13 c0.3,0,0.5-0.2,0.5-0.5V10c0-0.1-0.1-0.2-0.2-0.2h-0.5C14.1,9.7,14,9.9,14,10z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Strokes",
    className: "st1"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    style: {
      fill: "transparent"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/DownloadIcon.d38e773f4fd28e18362fb1755fd59655.svg";
export { ForwardRef as ReactComponent };